import React from 'react';
import { cn } from '@/lib/utils';

interface CardMetaTextProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
}

export const cardMetaTextClassName = 'mt-1 text-xs text-muted-foreground';

export const CardMetaText: React.FC<CardMetaTextProps> = ({ children, title, className }) => (
  <div title={title} className={cn(cardMetaTextClassName, className)}>
    {children}
  </div>
);
